import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import {
  CommentImageView,
  type CommentImagePreviewStorage
} from '../components/CommentImageView';

export function createPreviewableImageExtension() {
  return Image.extend({
    addStorage(): CommentImagePreviewStorage {
      return {};
    },

    addNodeView() {
      return ReactNodeViewRenderer(CommentImageView);
    }
  });
}
